import React from 'react'
import ModalProject from '../organims/ModalProject'

const CardProject=(props)=>{

  const openModal=(e)=>{
    let m=document.getElementById(`modal${props.id}`)
    m.classList.add('active');
    for (let i = 1; i < props.images.length+1; i++) {
      document.documentElement.style.setProperty(`--back-${i}`,`url(${props.images[i-1]})`)
    }

    if (props.video){
      let modal=document.getElementById(`modal${props.id}`)
      modal.classList.add('back-video')
      document.documentElement.style.setProperty(`--back-video`,`url(${props.images[1]})`)
    }
  }

  return (
    <>
    <div onClick={openModal.bind(this)} className="pointer card-project">
          <div className="project-image-container">
            <img src={props.image} alt="card-project" className="project-image"/>
          </div>
          <div id='card-body' className="card-body">
          <p className="project-description">{props.description}</p>
          <p className='watch-more'>Ver mas...</p>
          <div className="project-tools-container">
            <p className="project-tools-text">
              {props.tools}
            </p>
          </div>
          </div>
    </div>
    {<ModalProject id={props.id} url={props.url} longDescription={props.longDescription} tools={props.tools}/>}</>
  )
}

export default CardProject
